import { useState } from "react";
import { Dialog, DialogContent } from "@mui/material";
import { DialogTitleWithClose } from "./DialogTitleWithClose";
import { TransactionFilters } from "./TransactionFilters";
import { TransactionList } from "./TransactionList";
import type { GetTransactionsQueryDto, ImportItem } from "../api/types";

export type ImportTransactionsModalProps = {
  importItem: ImportItem;
  onClose: () => void;
};

const buildInitialFilters = (
  importItem: ImportItem,
): GetTransactionsQueryDto => ({
  startDate: null,
  endDate: null,
  source: null,
  group: null,
  category: null,
  merchant: null,
  description: null,
  autoTransactionId: null,
  importId: importItem.id,
  ignored: null,
  limit: 10,
  cursor: null,
  sort: "dateDesc",
});

export const ImportTransactionsModal = ({
  importItem,
  onClose,
}: ImportTransactionsModalProps) => {
  const [filters, setFilters] = useState<GetTransactionsQueryDto>(() =>
    buildInitialFilters(importItem),
  );

  const handleFiltersChange = (partial: Partial<GetTransactionsQueryDto>) => {
    setFilters((prev) => ({ ...prev, ...partial }));
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitleWithClose onClose={onClose}>
        Transactions from {importItem.importerName}
      </DialogTitleWithClose>
      <DialogContent>
        <TransactionFilters
          filters={filters}
          onFiltersChange={handleFiltersChange}
        />
        <TransactionList filters={filters} />
      </DialogContent>
    </Dialog>
  );
};
